import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import { IArticle } from "../../../gatsby-graphql"
import { Heading } from "../../ui"
import {
  ArticleWrapper,
  BottomWrapper,
  Category,
  Content,
  ContentWrapper,
  Date,
  Excerpt,
  Social,
  Thumb,
  TopWrapper,
} from "./article-preview-elements"

interface ArticlePreviewProps {
  data: IArticle
  basePath: string
  layout?: "horizontal" | "vertical"
  className?: string
  showExcerpt?: boolean
}

const ArticlePreview = ({
  data,
  basePath,
  layout = "horizontal",
  className = "",
  showExcerpt = true,
}: ArticlePreviewProps) => {
  if (!data) {
    return null
  }
  return (
    <ArticleWrapper className={`${layout} ${className}`}>

      <Thumb
        to={`${basePath}${data.slug}/`}
        className={`${layout} ${className}`}
      >
        {data.thumbnail && (
          <GatsbyImage
            image={data.thumbnail.localFile?.childImageSharp?.gatsbyImageData}
            alt=""
          />
        )}
      </Thumb>
      <ContentWrapper className={`${layout} ${className}`}>
        <TopWrapper>
          {data.category && <Category>{data.category.name}</Category>}
          <Date className="top-date" format="DD.MM.YYYY">
            {data.published_at}
          </Date>
        </TopWrapper>
        <Content to={`${basePath}${data.slug}/`}>
          <Heading.H3>{data.title}</Heading.H3>
          {showExcerpt && data.excerpt && <Excerpt>{data.excerpt}</Excerpt>}
        </Content>
        <BottomWrapper>
          <Date className="bottom-date" format="DD.MM.YYYY">
            {data.published_at}
          </Date>
          <Social></Social>
        </BottomWrapper>
      </ContentWrapper>
    </ArticleWrapper>
  )
}

export default ArticlePreview
